module.exports = __webpack_public_path__ + "b056889bfea4a937dc4398854136dfe5.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-1024.webp.png
// module id = 422
// module chunks = 0